<script type="text/babel">
import { interval } from 'rxjs'
import { merge } from 'lodash-es/object'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreScrollOnPageBack from 'dashboard-js/mixins/RestoreScrollOnPageBack'
import UserProvider from 'dashboard-js/providers/UserProvider'

export default {
    mixins: [ManagesModalState, HasSubscriptions, RestoreScrollOnPageBack],

    props: ['dataChannels', 'platforms', 'user'],

    data() {
        return {
            channels: this.dataChannels,
            events: [
                'ChannelResourcesInvalid',
                'ChannelResourceUpdated',
                'ChannelReachUpdated',
                'ChannelRefreshFailed',
            ],
            promptedChannels: [],
        }
    },

    computed: {
        connectingChannels() {
            return this.channels.filter(channel => channel.status === 'connecting')
        },
    },

    created() {
        this.events.forEach(event =>
            this.subscribe(
                UserProvider.listen(
                    'Services\\Platforms\\Events\\' + event,
                    this.updateChannelFromEvent
                )
            )
        )

        // In case a socket connection went wrong, we'll poll for updates on interval
        this.subscribe(interval(10000), () => {
            if (this.connectingChannels.length > 0) {
                this.getFresh()
            }
        })

        UserProvider.whenConnected(this.getFresh)
    },

    methods: {
        getFresh() {
            return axios.get(route('api.profile.channels')).then(response => {
                response.data.data.forEach(channel => this.updateChannel(channel))
            })
        },

        isNewChannelWithMultipleResources(oldChannel, newChannel) {
            if (oldChannel.resources === null && newChannel.resources !== null) {
                return newChannel.resources.length > 1
            }
            return false
        },

        selectAnalyticsProperty(channel) {
            this.openModal('select-analytics-property', { channel })
        },

        selectInstagramBusinessProperty(channel) {
            this.openModal('select-instagram-business-property', { channel })
        },

        updateChannelFromEvent(event) {
            this.updateChannel(event.channel)
        },

        updateChannel(updatedChannel) {
            let merged = false

            this.channels.forEach((existingChannel, idx) => {
                if (existingChannel.id === updatedChannel.id) {
                    this.maybePromptResourceSelector(updatedChannel)

                    merge(this.channels[idx], updatedChannel)
                    merged = true
                }
            })

            if (!merged) {
                this.channels.push(updatedChannel)
            }
        },

        maybePromptResourceSelector(channel) {
            if (
                channel.resource_id === null &&
                channel.resources !== null &&
                channel.status === 'connecting' &&
                this.promptedChannels.indexOf(channel.id) === -1
            ) {
                if (channel.platform_id === this.platforms.analytics.id) {
                    this.selectAnalyticsProperty(channel)
                } else if (channel.platform_id === this.platforms.instagram_business.id) {
                    this.selectInstagramBusinessProperty(channel)
                }
                this.promptedChannels.push(channel.id)
            }
        },
    },
}
</script>
<style>
.signup-4 .InfluencerSettingsChannelsPage {
    .ChannelCard {
        background: #fff;
        padding-left: 20px;
        padding-right: 20px;

    }

    hr {
        width: calc(100% - 40px) !important;

    }
}
</style>